import request from '@/utils/request';

// 销售-- 销售数据概况
export function api_realTimeBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/realTimeBank',
    method: 'get',
    params: params
  });
}

// 销售-- 销售额趋势
export function api_sumOrderChatBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/sumOrderChatBank',
    method: 'get',
    params: params
  });
}

// 销售-- 商品排行榜
export function api_listOrderRankingBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/listOrderRankingBank',
    method: 'get',
    params: params
  });
}

// 销售-- 店铺排行榜
export function api_listShopOrderRankingBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/listShopOrderRankingBank',
    method: 'get',
    params: params
  });
}

// 门店-- 销售数据概况
export function api_realTimeCashierBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/realTimeCashierBank',
    method: 'get',
    params: params
  });
}

// 门店-- 销售额趋势
export function api_sumCashierOrderChatBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/sumCashierOrderChatBank',
    method: 'get',
    params: params
  });
}

// 门店-- 商品排行榜
export function api_listCashierOrderRankingBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/listCashierOrderRankingBank',
    method: 'get',
    params: params
  });
}

// 门店-- 店铺排行榜
export function api_listShopCashierOrderRankingBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/listShopCashierOrderRankingBank',
    method: 'get',
    params: params
  });
}

// 销售单-- 销售数据概况
export function api_realTimeSaleStorageBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/realTimeSaleStorageBank',
    method: 'get',
    params: params
  });
}

// 销售单-- 销售额趋势
export function api_sumSaleStorageChatBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/sumSaleStorageChatBank',
    method: 'get',
    params: params
  });
}

// 销售单-- 商品排行榜
export function api_listSaleStorageRankingBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/listSaleStorageRankingBank',
    method: 'get',
    params: params
  });
}

// 销售单-- 店铺排行榜
export function api_listShopSaleStorageRankingBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/listShopSaleStorageRankingBank',
    method: 'get',
    params: params
  });
}

// 销售-- 订单统计
export function api_summaryCashierOrderBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/summaryCashierOrderBank',
    method: 'get',
    params: params
  });
}

// 销售-- 订单列表
export function api_getCashierPageDataBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/getCashierPageDataBank',
    method: 'get',
    params: params
  });
}

//  订单列表
export function api_listAllOrderBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/listAllOrderBank',
    method: 'get',
    params: params
  });
}

//  门店订单
export function api_getCashierOrderListBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/getCashierOrderListBank',
    method: 'get',
    params: params
  });
}

//  门店订单
export function api_saleStoragePageBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/saleStoragePageBank',
    method: 'get',
    params: params
  });
}

//  电商订单详情
export function api_getOrderDetail(params) {
  return request({
    url: '/bussscreen/bankStatistics/getOrderDetail',
    method: 'get',
    params: params
  });
}

//  门店订单详情
export function api_getCashierOrderDetail(params) {
  return request({
    url: '/bussscreen/bankStatistics/getCashierOrderDetail',
    method: 'get',
    params: params
  });
}

//  销售单详情
export function api_getSaleStorageDetail(params) {
  return request({
    url: '/bussscreen/bankStatistics/getSaleStorageDetail',
    method: 'get',
    params: params
  });
}

//  订单统计
export function api_sumOrderBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/sumOrderBank',
    method: 'get',
    params: params
  });
}

//  采购单列表
export function api_listPurchaseBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/listPurchaseBank',
    method: 'get',
    params: params
  });
}

//  采购单统计
export function api_sumPurchaseBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/sumPurchaseBank',
    method: 'get',
    params: params
  });
}

//  采购单详情
export function api_selectPurchaseDetail(params) {
  return request({
    url: '/bussscreen/bankStatistics/selectPurchaseDetail',
    method: 'get',
    params: params
  });
}

//  采购单概况
export function api_realTimePurchaseBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/realTimePurchaseBank',
    method: 'get',
    params: params
  });
}

//  采购额趋势
export function api_sumPurchaseChatBank(params) {
  return request({
    url: '/bussscreen/bankStatistics/sumPurchaseChatBank',
    method: 'get',
    params: params
  });
}
